var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"po-r mt20 w100 tx-c white flex-box al-c ju-c"},[_c('img',{staticClass:"mr10",attrs:{"src":(_vm.baseUrl + "images/logo-footer.png")}}),_c('span',{staticClass:"mr10"},[_vm._v("Copyright © 南宁职业技术学院版权所有")])])])}
var staticRenderFns = []

export { render, staticRenderFns }